import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { getCarrierServiceLabel } from "@redotech/redo-fulfillment-carrier-common/carrier-service-labels";
import { CarrierAndService } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import {
  LogoSize,
  ShippingLogo,
} from "@redotech/redo-web/fulfillment/common/shipping-logo";
import { memo } from "react";

export const DynamicRatePricingServiceLabel = memo(
  function DynamicRatePricingServiceLabel({
    source,
  }: {
    source: CarrierAndService;
  }) {
    return (
      <Flex align="center" gap="sm">
        <ShippingLogo carrier={source.carrier} size={LogoSize.SMALL} />
        <Text fontSize="sm">
          {getCarrierServiceLabel(source.carrier, source.service)}
        </Text>
      </Flex>
    );
  },
);
